export default __webpack_public_path__ + "static/media/pdf.3be5a08c.svg";